import styled from 'styled-components';
import { Text } from '@arcadiapower/shrike';

export const BankName = styled(Text).attrs({
  color: 'primary',
  textStyle: 'paragraph500',
})``;
